import React from 'react';

import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

interface ClientFormFieldProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  placeholder?: string;
  multiline?: boolean;
  pattern?: RegExp;
  maxLength?: number;
  disabled?: boolean;
  isSelect?: boolean;
  options?: { value: string; label: string }[];
}

export const ClientFormField: React.FC<ClientFormFieldProps> = ({
  name,
  value,
  onChange,
  type = 'text',
  placeholder,
  multiline = false,
  pattern,
  maxLength,
  disabled = false,
  isSelect = false,
  options = [],
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    let newValue = e.target.value;

    // Apply pattern filter if provided
    if (pattern) {
      newValue = newValue.replace(pattern, '');
    }

    // Apply max length if provided
    if (maxLength) {
      newValue = newValue.slice(0, maxLength);
    }

    onChange(newValue);
  };

  if (isSelect) {
    return (
      <Select value={value ?? ''} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger id={name} className="h-9">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  if (multiline) {
    return (
      <Textarea
        id={name}
        name={name}
        value={value ?? ''}
        onChange={handleChange}
        placeholder={placeholder}
        className="resize-none min-h-[100px]"
        disabled={disabled}
      />
    );
  }

  return (
    <Input
      id={name}
      name={name}
      type={type}
      value={value ?? ''}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      className="h-9"
    />
  );
};
